import {call, put} from "redux-saga/effects";
import {
  changesStatus,
  createDeliveryUser,
  deliveryUser,

} from "../requests/deliveryService";
import {
  getDeliveryUsers,
  setDeliveryUsers,
  setError,
  setLoading,
  setSuccess,
  setUpdatedUser,
  setUpdateIndex
} from "../../slices/deliverySlice";
import {toast} from "react-toastify";

export function* handleGetDeliveryUser(action) {

  try {
    yield put(setLoading(true))
    const response = yield call(() => deliveryUser(action.payload))
    yield put(setDeliveryUsers(response.data))

  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message;
    yield put(setError(errMsg))
  }
}

export function* handleCreateDeliveryUser(action) {

  try {
    yield put(setLoading(true))
    const response = yield call(() => createDeliveryUser(action.payload))
    yield put(setUpdatedUser(response.data))
    toast.success(`Successfully registered`)
    yield put(setSuccess(true))

  } catch (error) {

    const errMsg = error.response ? error.response.data.message : error.message;
    yield put(setError(errMsg))
    toast.error(errMsg)
  }
}

export function* handleChangeStatus(action) {
  const query = action.payload
  try {
    // yield put(setLoading(true))
    const response = yield call(() => changesStatus(query))
    yield put(setUpdateIndex({
      index: action.payload.index,
      status: query.status,
    }))
    toast.success(`Successfully status changed`)
    yield put(setSuccess())

  } catch (error) {
    toast.error(error.message)
  }
}
